<tui-hosted-dropdown
    #table
    tuiDropdownAlign="left"
    tuiDropdownDirection="bottom"
    [content]="tableDropdown"
>
    <button
        tuiIconButton
        type="button"
        size="s"
        icon="tuiIconTableLarge"
        appearance="icon"
        tuiHintDirection="top-left"
        tuiHintDescribe
        [tuiHint]="insertTableText$ | async"
        [focusable]="table.open"
    ></button>
</tui-hosted-dropdown>

<ng-template #tableDropdown>
    <tui-table-size-selector (onSelectSize)="addTable($event)"></tui-table-size-selector>
</ng-template>
